"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStations = void 0;
var hooks_1 = require("../../hooks");
var useStations = function () { return (0, hooks_1.useAppSelector)(function (state) { return state.stations; }); };
exports.useStations = useStations;
